<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>工资模块</el-breadcrumb-item>
            <el-breadcrumb-item>打卡记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="0" class="grid-content">
      <el-col :span="10">
        <div class="grid-content">
          员工名称：
          <el-input
            v-model="name"
            style="width: unset;"
            placeholder="请输入员工名称"
          ></el-input>
        </div>
        <div class="grid-content">
          选择时间：
          <el-date-picker
            v-model="month"
            type="month"
            value-format="yyyy-MM"
            format="yyyy-MM"
            style="width: 200px;"
            placeholder="选择月"
          ></el-date-picker>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="grid-content">
          员工电话：
          <el-input
            v-model="tel"
            style="width: unset;"
            placeholder="请输入员工电话"
          ></el-input>
        </div>
        <div class="grid-content">
          <el-button type="primary" size="small" @click="getClockin"
            >查询</el-button
          >
          <!-- <el-button type="primary" size="small">新增</el-button> -->
          <!-- <el-button type="primary" size="small">导出</el-button> -->
        </div>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      border
      @row-click="goPunchStatisticsdDetails"
      style="width: 95%"
    >
      <el-table-column prop="month" label="时间"></el-table-column>
      <el-table-column prop="staffName" label="姓名"></el-table-column>
      <el-table-column prop="tel" label="电话"></el-table-column>
      <el-table-column prop="normalDays" label="正常上班(天)"></el-table-column>
      <el-table-column
        prop="abnormalDays"
        label="迟到/早退(天)"
      ></el-table-column>
      <el-table-column prop="absenceDays" label="未打卡(天)"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import { clockinSta } from "@/api/clockin";
import moment from "moment";
export default {
  data() {
    return {
      month: moment(new Date()).format("YYYY-MM"),
      name: "",
      tel: "",
      tableData: []
    };
  },
  mounted() {
    this.getClockin();
  },
  methods: {
    goPunchStatisticsdDetails(row) {
      console.log(row);
      this.$router.push({
        path: "punchStatisticsddetails",
        query: {
          userId: row.userId,
          staffName: row.staffName,
          tel: row.tel,
          month: row.month
        }
      });
    },
    getClockin() {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        month: this.month,
        tel: this.tel,
        staffName: this.name
      };
      clockinSta(params)
        .then(res => {
          // console.log(res);
          var tableData = [];
          res.gridData.forEach(element => {
            tableData.push(element);
          });
          this.tableData = tableData;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
